import {useState, React }from 'react';
import { useLocation, useNavigate } from "react-router-dom";
function Footer() {
  const navigate = useNavigate();
  const [openItem, setOpenItem] = useState(null);

  const toggle = (item) => {
    setOpenItem(openItem === item ? null : item);
  };

  return (
    <footer id="footer">
    <div className="footer-top">
      <div className="container">
        <div className="row">

          <div className="col-lg-2 col-md-4 col-6 ">
            <div className="footer-info">
             
             <img src='/assets/img/logo/mensatrans2.png' alt='' style={{width:'80%', borderRadius:'20px'}}>
             </img>
            </div>
          </div>

          <div className="col-lg-2 col-md-4 footer-links">
            <h4>About Us</h4>
            <ul>
              <li><i className="bx bx-chevron-right"></i>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/AboutUs", { state: { tab: "#one" } });
                  }}
                >Let’s talk IQ
                </a>
              </li>
              <li><i className="bx bx-chevron-right"></i>
                <a href="https://www.mensa.org" target='blank'>Mensa International</a></li>
              <li><i className="bx bx-chevron-right"></i>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/AboutUs", { state: { tab: "#three" } });
                  }}
                >Mensa India History</a></li>
              <li><i className="bx bx-chevron-right"></i>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/AboutUs", { state: { tab: "#four" } });
                  }}
                >Mensa statistics</a></li>
             
            </ul>
          </div>

          <div className="col-lg-2 col-md-4 footer-links">
            <h4>Join Us</h4>
            <ul>
              <li><i className="bx bx-chevron-right"></i>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/JoinUs", { state: { tab: "#one" } });
                  }}
                >
                  Why Join Mensa ?
                </a>
              </li>
              <li><i className="bx bx-chevron-right"></i>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/Pretest");
                  }}
                >
                  Online Mensa Pre-Test
                </a>
              </li>
              <li>
                <i className="bx bx-chevron-right"></i>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/JoinUs", { state: { tab: "#two" } });
                  }}
                >
                  Book Your Test
                </a>
              </li>
              <li><i className="bx bx-chevron-right"></i>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/JoinUs", { state: { tab: "#three" } });
                  }}
                >Prior Evidence
                </a>
              </li>
              <li><i className="bx bx-chevron-right"></i>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/JoinUs", { state: { tab: "#four" } });
                  }}
                >joining FAQ </a></li> 
            </ul>
          </div>
 <div className="col-lg-2 col-md-4 footer-links">
      <h4>Contact Us</h4>
      <ul>

        {/* Contact Details */}
        <li>
          <i className="bx bx-chevron-right"></i>
          <span className="expand-link" onClick={() => toggle("contact")}>
            Contact Details
          </span>
        </li>
          {openItem === "contact" && (
            <div className="expand-email">
              <a href="mailto:mensahq@mensaindia.org">
                mensahq@mensaindia.org
              </a>
            </div>
          )}

        {/* SIGHT */}
        <li>
          <i className="bx bx-chevron-right"></i>
          <span className="expand-link" onClick={() => toggle("sight")}>
            Sight
          </span>
        </li>

        {openItem === "sight" && (
            <div className="expand-email">
              <a href="mailto:SIGHT@mensaindia.org">
                SIGHT@mensaindia.org
              </a>
            </div>
          )}

      </ul>
    </div>
          {/* <div className="col-lg-4 col-md-6 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>"Newsletter Subscription Form"
              <br></br>
            Write to us : mensahq@mensaindia.org
            </p>
            <form action="" method="post">
              <input type="email" name="email"></input><input type="submit" value="Subscribe"></input></form>
            <div className="social-links mt-3">
                <a href="#" className="twitter"><i className="bx bxl-twitter"></i></a>
                <a href="#" className="facebook"><i className="bx bxl-facebook"></i></a>
                <a href="#" className="instagram"><i className="bx bxl-instagram"></i></a>
                <a href="#" className="linkedin"><i className="bx bxl-linkedin"></i></a>
              </div>
          </div> */}
          <div className="col-lg-4 col-md-4 footer-newsletter">
            {/* <div className="email">
                  <h4 className='p-0'><i className="icofont-envelope"></i> Email:</h4>
                  <p> mensahq@mensaindia.org</p>
            </div> */}
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="copyright">
        &copy; Copyright <strong><span>Mensa</span></strong>. All Rights Reserved. Designed by <a href="https://csismtechnologies.com/">CSism Technologies</a>
      </div>
      <div className="credits">
        
        
      </div>
    </div>
    
  </footer>
  );
}

export default Footer;
